import type { ReactNode } from "react";

interface PageHeaderProps {
  eyebrow: string;
  title: string;
  meta?: ReactNode;
  action?: ReactNode;
}

export function PageHeaderV2({ eyebrow, title, meta, action }: PageHeaderProps) {
  return (
    <div className="flex items-end justify-between pb-5">
      <div>
        <p className="font-mono text-[11px] font-semibold uppercase tracking-[0.16em] text-teal-700 dark:text-teal-300">
          {eyebrow}
        </p>
        <h1 className="mt-1.5 text-[32px] font-bold leading-[0.95] tracking-[-0.05em] text-ink">
          {title}
        </h1>
        {meta && <div className="mt-2 font-mono text-xs font-medium text-muted">{meta}</div>}
      </div>
      {action && <div>{action}</div>}
    </div>
  );
}
